import { gql } from "urql";

export const drgRecalculateMutationDoc = gql`
  mutation drgRecalculate($claimId: ID!, $includeAuditorCodes: Boolean!) {
    drgRecalculate(claimId: $claimId) {
      claim {
        id
        drgStatus
        estimatedOverpaymentCents
        originalGrouping {
          drgCode
          drgDescription
          relativeWeight
          soi
          rom
          ccMcc
        }
        recalculatedGrouping {
          drgCode
          drgDescription
          relativeWeight
          rwDeltaVsBilled
          soi
          rom
          ccMcc
        }
        codes {
          id
          codeKind
          code
          codeDescription
          role
          paymentImpact
          paymentImpactAmount
          poa
          soi
          rom
          finalCcMccFlag
          claimCodeStatus
          metadata {
            code
            description
            hierarchy
            isBillable
            notes
          }
        }
        # auditorCodes only exists on the claim-code-management backend.
        # Skip it for legacy requests, matching the guard in getDrgClaim.gql.ts.
        auditorCodes @include(if: $includeAuditorCodes) {
          id
          codeKind
          code
          codeDescription
          role
          paymentImpact
          paymentImpactAmount
          poa
          soi
          rom
          finalCcMccFlag
          claimCodeStatus
          createdBy {
            id
            displayName
          }
          findingId
          metadata {
            code
            description
            hierarchy
            isBillable
            notes
          }
        }
      }
    }
  }
`;
